export class Key {
    constructor(id) {
        this.id = id;
    }
    getId() {
        return this.id;
    }
    getValue(container) {
        return container.getValue(this);
    }
}
